import { useDispatch, useSelector } from 'react-redux';
import { Creators as profileActions } from '../../domain/useCases/getProfile';

const useProfile = () => {
  const dispatch = useDispatch();
  const call = () => dispatch(profileActions.getProfile());
  const { data } = useSelector((state: any) => state.profile);
  const academic = data?.academic;
  const profile = data?.profile;

  const getValue = (fieldName: string) => {
    if (['emplid', 'peopleCode', 'studentId'].includes(fieldName)) {
      return profile.peopleCode;
    }

    if (['studentCode', 'codutpalu'].includes(fieldName)) {
      return profile.studentCode;
    }

    if (['dni'].includes(fieldName)) {
      return profile.dni;
    }

    if (['grado', 'career'].includes(fieldName)) {
      return academic.career;
    }

    if (['campus'].includes(fieldName)) {
      return academic.campus;
    }

    if (['plan'].includes(fieldName)) {
      return academic.plan;
    }

    if (['strm'].includes(fieldName)) {
      return academic.period.id;
    }

    if (['acadProg', 'program'].includes(fieldName)) {
      return academic.progDesc;
    }
    return null;
  };

  const transformId = (id: string) => {
    switch (id.substring(3, 4)) {
      case '1':
        return `Ciclo Verano 20${id.substring(1, 3)}`;
      case '2':
        return `Ciclo Marzo 20${id.substring(1, 3)}`;
      default:
        return `Ciclo Agosto 20${id.substring(1, 3)}`;
    }
  };

  return { call, academic, profile, getValue, transformId };
};

export default useProfile;
